import Button from "components/form/Button";
import Card from "components/Layout/Card";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { icons } from "utils/constants";

const AbstractSubmitSuccessPopup = ({ onHide, isSuccess, submission_type, eventData, abstract_id }) => {
  const params = useParams();
  const {
    eventType = 'conference',
    memberType,
    moduleType,
    eventId
  } = params;
  const navigate = useNavigate();
  return (
    <Card className="cpt-60 h-100">
      <div className=" d-flex flex-column align-items-center ">
        <div className="cmb-27">
          <img src={icons?.abstractDone} alt="logo" height={55} width={55} />
        </div>
        <div className="color-a35b text-24-700-30 cmb-27">
          {submission_type} Submitted Successfully
        </div>
        <p className="text-16-300-20 color-black cmb-8">
          {/* Your abstract has been submitted successfully. */}
          {`Your ${submission_type} has been submitted to ${eventData?.event_short_name}. We'll notify you once the review is completed.`}
        </p>
        <p className="text-16-300-20 color-black cmb-24">
          🎉 Speed up your research journey with Human + AI
        </p>

        <div className="d-flex flex-wrap justify-content-between border rounded cp-20 bg-f4fc cmb-24">
          <div className="border-end flex-fill text-center cps-20 cpe-20 cmb-24 mb-md-0">
            <span role="img" aria-label="research">🔍 ResearchPedia</span> <br />
            <span>Literature Review</span>
          </div>
          <div className="border-end flex-fill text-center cps-20 cpe-20 cmb-24 mb-md-0">
            <span role="img" aria-label="chat">💬 Chat with Doc</span> <br />
            <span>AI Q&A on research</span>
          </div>
          <div className="flex-fill text-center cps-20 cpe-20">
            <span role="img" aria-label="cv">📝 CV Builder</span> <br />
            <span>Resume Generator</span>
          </div>
        </div>

        <div className="d-flex align-items-center gap-3">
          <Button
            id="btn_view_track"
            text="View Track"
            btnStyle="primary-dark"
            className="cps-20 cpe-20 h-37"
            onClick={() => {
              navigate(
                `/${memberType}/my-profile/my-events/abstract/tracking/${eventId}/${abstract_id}`
              );
              // navigate(`/${memberType}/my-profile/my-events/${eventId}`);
            }}
          />
          <Button
            id="btn_new_submission"
            text="Start New Submission"
            btnStyle="light-outline"
            className="cps-20 cpe-20 h-37"
            onClick={() => {
              navigate(`/${memberType}/${moduleType}/${eventType}/${eventId}/abstract-submission/add-abstract-submission`);
              window.location.reload();
            }}
          />
        </div>
      </div>
    </Card>
  );
};

export default AbstractSubmitSuccessPopup;
